export default __webpack_public_path__ + "static/media/fotogra.3b6bb807.jpg";